import React from 'react';
import { Box, Button } from '@mui/material';
import StyledBox from 'views/rebranded-module/tours-module/TourViewV2/components/SelectTourFixedBar/SelectTourFixedBar.styles';

const SelectTourFixedBar = (props) => {
  const { content, handleActionButtonClick } = props;
  return (
    <StyledBox>
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        <Box>
          <Button
            color="primary"
            variant="contained"
            onClick={handleActionButtonClick}>
            {content.actionBarBtnText}
          </Button>
        </Box>
      </Box>
    </StyledBox>
  );
};

export { SelectTourFixedBar };
